import { render, staticRenderFns } from "./FarmersVerifier.vue?vue&type=template&id=fda20e20&"
import script from "./FarmersVerifier.vue?vue&type=script&lang=js&"
export * from "./FarmersVerifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports